import { ReactNode } from 'react';
import { Popover, PopoverContent, PopoverTrigger, Tooltip } from '@ds';

export type CaseDuplicatesTriggerProps = {
  trigger: ReactNode;
  triggerType?: 'click' | 'hover';
  hideTooltip: boolean;
  content: ReactNode;
  className?: string;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export const CaseDuplicatesTrigger = ({
  trigger,
  triggerType = 'click',
  hideTooltip,
  content,
  className = '',
  isOpen,
  onOpenChange,
}: CaseDuplicatesTriggerProps) => {
  const safeTrigger = (
    <div className="cursor-pointer" role="presentation" onClick={(e) => e.stopPropagation()}>
      {trigger}
    </div>
  );

  if (!hideTooltip && triggerType === 'hover') {
    return (
      <Tooltip placement="bottom-start" className={className} content={content}>
        {safeTrigger}
      </Tooltip>
    );
  }

  if (triggerType === 'click') {
    return (
      <Popover placement="bottom-end" isOpen={isOpen} onOpenChange={onOpenChange} shouldCloseOnBlur offset={10}>
        <PopoverTrigger>{safeTrigger}</PopoverTrigger>
        <PopoverContent className="p-0">{content}</PopoverContent>
      </Popover>
    );
  }

  return safeTrigger;
};
